export const POSTHOG_URL = "https://poshog.moulook.com";
// export const POSTHOG_KEY = "phc_S9XHtA1ChFCzDtRQbLlyszDpBhylVtvcWPgbKdhgxKx";
export const POSTHOG_KEY = "phc_fisN1npQ9KkhBdztauKNkMj2ITY4DOEwLKVCpihBRBm";

// export const POSTHOG_URL = "https://us.i.posthog.com";
// export const POSTHOG_KEY = "phc_7tDcJHBuN51kSz1d6yKuTI8RWxQaJSWwo7YgU760Mbw";


//phc_fisN1npQ9KkhBdztauKNkMj2ITY4DOEwLKVCpihBRBm